import { useSearchParams } from 'next/navigation';

const DEFAULT_PAGE = 1;

const parsePage = (value: string | null): number => {
    if (!value) {
        return DEFAULT_PAGE;
    }

    const page = Number(value);
    if (!Number.isInteger(page) || page < DEFAULT_PAGE) {
        return DEFAULT_PAGE;
    }

    return page;
};

export const usePage = () => {
    const params = useSearchParams();
    return parsePage(params.get('page'));
};
